module.exports = "<p>\n  dept-exam-record-from works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component.html
// module id = ./src/app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component.html
// module chunks = main